export default __webpack_public_path__ + "static/media/node_logo.9c51c788.png";